// frontend/src/components/CrearRecursoModal.jsx
import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import presupuestosService from '../services/presupuestosService';
import './CrearModal.css';

import Loading from './Loading';
const CrearRecursoModal = ({ partidaId, onClose, onRecursoAdded }) => {
  const [formData, setFormData] = useState({
    nombre_recurso: '',
    descripcion: '',
    cantidad: '',
    valor_unitario: '',
    unidad: 'unidad',
    proveedor: '',
    status: 'activo'
  });
  const [proveedores, setProveedores] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedProveedor, setSelectedProveedor] = useState(null);

  useEffect(() => {
    cargarProveedores();
  }, []);

  const cargarProveedores = async () => {
    try {
      const response = await presupuestosService.getProveedores();
      console.log('🔍 getProveedores response:', response.data);

      let proveedoresData = [];

      // Manejar respuesta paginada de Django REST Framework
      if (response.data && response.data.results && Array.isArray(response.data.results)) {
        console.log('✅ Proveedores (paginado):', response.data.results.length);
        proveedoresData = response.data.results;
      }
      // Manejar respuesta directa de array
      else if (Array.isArray(response.data)) {
        console.log('✅ Proveedores (array directo):', response.data.length);
        proveedoresData = response.data;
      }
      // Error: estructura no reconocida
      else {
        console.warn('⚠️ Proveedores estructura no reconocida:', response.data);
        proveedoresData = [];
      }

      setProveedores(proveedoresData);
    } catch (error) {
      console.error('Error al cargar proveedores:', error);
      setProveedores([]);
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.nombre_recurso.trim()) {
      toast.error('El nombre del recurso es requerido');
      return;
    }

    onRecursoAdded({
      ...formData,
      cantidad: parseFloat(formData.cantidad) || 0,
      valor_unitario: parseFloat(formData.valor_unitario) || 0,
      proveedor: formData.proveedor ? parseInt(formData.proveedor) : null
    });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));

    // Update selected proveedor when proveedor changes
    if (name === 'proveedor') {
      const proveedor = proveedores.find(p => p.id === parseInt(value));
      setSelectedProveedor(proveedor || null);
    }
  };

  if (loading) {
    return (
      <div className="crear-modal-overlay" onClick={onClose}>
        <div className="crear-modal-content" onClick={e => e.stopPropagation()}>
          <div className="modal-header">
            <h2>➕ Crear Recurso</h2>
            <button className="modal-close" onClick={onClose}>✕</button>
          </div>
          <Loading fullScreen={false} size="sm" />
        </div>
      </div>
    );
  }

  return (
    <div className="crear-modal-overlay" onClick={onClose}>
      <div className="crear-modal-content" onClick={e => e.stopPropagation()}>
        <div className="modal-header">
          <h2>➕ Crear Recurso</h2>
          <button className="modal-close" onClick={onClose}>✕</button>
        </div>

        <form onSubmit={handleSubmit} className="modal-form">
          <div className="form-group">
            <label>Nombre del Recurso *</label>
            <input
              type="text"
              name="nombre_recurso"
              value={formData.nombre_recurso}
              onChange={handleChange}
              placeholder="Ej: Servidor, Licencia, Consultor, etc."
              required
            />
          </div>

          <div className="form-group">
            <label>Descripción</label>
            <textarea
              name="descripcion"
              value={formData.descripcion}
              onChange={handleChange}
              placeholder="Descripción del recurso..."
              rows={2}
            ></textarea>
          </div>

          <div className="form-row">
            <div className="form-group">
              <label>Cantidad</label>
              <input
                type="number"
                name="cantidad"
                value={formData.cantidad}
                onChange={handleChange}
                min="0"
                step="0.01"
                placeholder="0"
              />
            </div>

            <div className="form-group">
              <label>Valor Unitario</label>
              <input
                type="number"
                name="valor_unitario"
                value={formData.valor_unitario}
                onChange={handleChange}
                min="0"
                step="0.01"
                placeholder="0"
              />
            </div>

            <div className="form-group">
              <label>Unidad</label>
              <select
                name="unidad"
                value={formData.unidad}
                onChange={handleChange}
              >
                <option value="unidad">Unidad</option>
                <option value="hora">Hora</option>
                <option value="día">Día</option>
                <option value="mes">Mes</option>
                <option value="año">Año</option>
                <option value="kg">kg</option>
              </select>
            </div>
          </div>

          <div className="form-group">
            <label>Proveedor</label>
            <select
              name="proveedor"
              value={formData.proveedor}
              onChange={handleChange}
            >
              <option value="">Sin proveedor</option>
              {Array.isArray(proveedores) && proveedores.map(proveedor => (
                <option key={proveedor.id} value={proveedor.id}>
                  {proveedor.nombre_proveedor}
                </option>
              ))}
            </select>
          </div>

          {selectedProveedor && (
            <div className="proveedor-info-box">
              <h4>📋 Información del Proveedor</h4>
              <div className="info-grid">
                {selectedProveedor.rut && (
                  <div className="info-item">
                    <span className="info-label">RUT:</span>
                    <span className="info-value">{selectedProveedor.rut}</span>
                  </div>
                )}
                {selectedProveedor.mail && (
                  <div className="info-item">
                    <span className="info-label">Mail Alternativo:</span>
                    <span className="info-value">{selectedProveedor.mail}</span>
                  </div>
                )}
                {selectedProveedor.email && (
                  <div className="info-item">
                    <span className="info-label">Email:</span>
                    <span className="info-value">{selectedProveedor.email}</span>
                  </div>
                )}
                {selectedProveedor.contacto && (
                  <div className="info-item">
                    <span className="info-label">Contacto:</span>
                    <span className="info-value">{selectedProveedor.contacto}</span>
                  </div>
                )}
                {selectedProveedor.telefono && (
                  <div className="info-item">
                    <span className="info-label">Teléfono:</span>
                    <span className="info-value">{selectedProveedor.telefono}</span>
                  </div>
                )}
              </div>
            </div>
          )}

          <div className="form-group">
            <label>Status</label>
            <select
              name="status"
              value={formData.status}
              onChange={handleChange}
            >
              <option value="activo">Activo</option>
              <option value="inactivo">Inactivo</option>
            </select>
          </div>

          <div className="modal-actions">
            <button type="button" className="btn btn-secondary" onClick={onClose}>
              Cancelar
            </button>
            <button type="submit" className="btn btn-primary">
              Crear Recurso
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CrearRecursoModal;
